import React, { useState } from 'react'
import { Image as ImageIcon } from 'lucide-react'
import ContentRenderer from '../../../components/ContentRenderer'
import { cardToContentItems } from '../lib/cardToContentItem'
import { genId } from '../lib/id'
import { compressImageFile } from '../../../utils/imageCompress'
import FileDropzone from '../components/FileDropzone'
import type { InfographicCard } from '../types/LessonDoc'
import type { CardDef, CardEditorProps, CardPreviewProps } from './types'

const IMG_ACCEPT = { 'image/*': ['.png', '.jpg', '.jpeg', '.webp', '.gif', '.svg'] }

const Editor: React.FC<CardEditorProps> = ({ card, onChange }) => {
  const c = card as InfographicCard
  const [busy, setBusy] = useState(false)

  const handleFile = async (file: File) => {
    setBusy(true)
    try {
      // Ảnh infographic thường nặng nhất → nén MẠNH hơn; chỉ lưu bản đã nén (ghi đè ảnh cũ)
      const dataUrl = await compressImageFile(file, { maxWidth: 1000, maxHeight: 1000, quality: 0.7 })
      onChange({ imageSrc: dataUrl })
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="space-y-3">
      <FileDropzone accept={IMG_ACCEPT} onFile={handleFile} busy={busy} label="Kéo-thả ảnh infographic" hint="PNG, JPG, WebP, SVG..." />
      <div>
        <label className="text-xs font-bold text-gray-500 uppercase">hoặc dán URL hình ảnh</label>
        <input
          className="w-full p-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-200"
          value={c.imageSrc}
          onChange={(e) => onChange({ imageSrc: e.target.value })}
          placeholder="https://.../infographic.png"
        />
      </div>
      <div>
        <label className="text-xs font-bold text-gray-500 uppercase">Chú thích (tuỳ chọn)</label>
        <input
          className="w-full p-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-200"
          value={c.caption || ''}
          onChange={(e) => onChange({ caption: e.target.value })}
        />
      </div>
    </div>
  )
}

const Preview: React.FC<CardPreviewProps> = ({ card }) => {
  const items = cardToContentItems(card)
  return items ? <ContentRenderer content={items} /> : null
}

export const infographicCardDef: CardDef = {
  type: 'infographic',
  label: 'Infographic',
  description: 'Hình ảnh minh hoạ',
  icon: ImageIcon,
  color: 'bg-amber-50 text-amber-600',
  createDefault: (): InfographicCard => ({ id: genId(), type: 'infographic', imageSrc: '' }),
  Editor,
  Preview,
}
